import clsx from 'clsx';
import React from 'react';

import Button from '@/src/components/common/Elements/Button/Button';
import Icon, { ICONS } from '@/src/components/common/Elements/Icon/Icon';

const PageNavigator = ({ currentPage, totalCount, onClickLeft, onClickRight }) => {
  return (
    <div className={clsx('tw-flex tw-items-center')}>
      <span
        className={clsx(
          'tw-font-brandonTextMedium tw-text-cfo-black tw-leading-[20px] tw-w-max tw-mx-[5px]'
        )}
      >
        {currentPage} of {totalCount}
      </span>
      <Button
        id={''}
        className={clsx('tw-text-cfo-black', 'tw-mr-0 tw-p-0')}
        onClick={onClickLeft}
        disabled={currentPage === 1}
      >
        <Icon icon={ICONS.arrow_left} />
      </Button>
      <Button
        id={''}
        className={clsx('tw-text-cfo-black', 'tw-mr-0 tw-p-0')}
        onClick={onClickRight}
        disabled={currentPage === totalCount}
      >
        <Icon icon={ICONS.arrow_right} />
      </Button>
    </div>
  );
};

export default PageNavigator;
